import { useMemo } from "react"
import { useNavigate } from "react-router-dom"
import { Brand, SubscriptionConfig } from "../../../../../../types"

interface Props {
  info: SubscriptionConfig
  brands: Brand[]
}

const NameCell = ({ info, brands }: Props) => {
  const navigate = useNavigate()
  const { id, brand_id } = info
  const brand = useMemo(
    () => brands.find(b => b.id === brand_id),
    [brand_id, brands]
  )

  const handleClick = () => {
    navigate(`/config-admin/subscription/${id}`)
  }

  return (
    <td
      className="whitespace-nowrap py-4 pl-2 pr-3 cursor-pointer hover:bg-gray-50"
      onClick={handleClick}
    >
      <div className="flex items-center">
        <div className="font-bold mr-2">
          {brand?.name ?? "Unknown brand"} Subscription Config
        </div>
      </div>
    </td>
  )
}

export default NameCell
